var _g, _g2, _path, _g3, _g4, _path2, _path3, _g5, _g6, _g7, _g8, _g9, _g10, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehousingandfulfillment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 112,
    viewBox: "0 0 118 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "warehousing and fulfillment"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3137_8300",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 112
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b7e986c375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.801514 0.416992H117.04V111.554H0.801514V0.416992Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3137_8300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0834 108.986H104.678V40.0682C104.678 39.3985 105.246 38.8549 105.947 38.8549H114.455V28.9183L58.8874 3.19015L3.30917 28.9183V38.8549H11.8159C12.5179 38.8549 13.0834 39.3985 13.0834 40.0682V108.986ZM105.947 111.412H11.8144C11.114 111.412 10.5454 110.869 10.5454 110.199V41.28H2.0402C1.70212 41.28 1.37919 41.1539 1.14117 40.9263C0.903139 40.6973 0.77124 40.39 0.77124 40.0682V28.1587C0.77124 27.6934 1.04868 27.2701 1.4838 27.0672L58.3355 0.750558C58.6842 0.589658 59.0905 0.589658 59.4392 0.750558L116.276 27.0672C116.715 27.2701 116.993 27.6934 116.993 28.1587V40.0682C116.993 40.7379 116.424 41.2815 115.724 41.2815L107.216 41.28V110.199C107.216 110.869 106.647 111.412 105.947 111.412Z",
    fill: "black",
    fillOpacity: 0.75
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8827 21.0745C53.5658 21.0745 49.2419 25.2086 49.2419 30.2893C49.2419 35.37 53.5658 39.5041 58.8812 39.5041C64.1951 39.5041 68.519 35.37 68.519 30.2893C68.519 25.2072 64.1936 21.0745 58.8827 21.0745ZM58.8827 41.9292C52.168 41.9292 46.707 36.7079 46.707 30.2893C46.707 23.8707 52.168 18.6479 58.8812 18.6479C65.5959 18.6479 71.0554 23.8707 71.0554 30.2893C71.0554 36.7079 65.5944 41.9307 58.8827 41.9292Z",
    fill: "black",
    fillOpacity: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3137_8300",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 47,
    width: 75,
    height: 65
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "df6c992a22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.8235 47.4204H95.954V111.554H21.8235V47.4204Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3137_8300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4792 111.412C93.7788 111.412 93.2087 110.87 93.2087 110.199L93.2102 50.0325H24.5558V110.199C24.5558 110.87 23.9858 111.412 23.2853 111.412C22.5849 111.412 22.0164 110.87 22.0164 110.199L22.0179 48.8192C22.0179 48.1495 22.5849 47.606 23.2853 47.606H94.4792C95.1781 47.606 95.7466 48.1495 95.7466 48.8192V110.199C95.7466 110.87 95.1781 111.412 94.4777 111.412H94.4792Z",
    fill: "black",
    fillOpacity: 0.75
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0611 32.8582H37.9761V27.721H21.0611V32.8582ZM39.2466 35.2847H19.7906C19.0917 35.2847 18.5232 34.7412 18.5232 34.0715V26.5077C18.5232 25.838 19.0902 25.2944 19.7906 25.2944H39.2466C39.9485 25.2944 40.514 25.838 40.514 26.5077L40.5155 34.07C40.5155 34.7412 39.9485 35.2847 39.2466 35.2847Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.785 32.8582H96.7V27.721H79.785V32.8582ZM97.9689 35.2847H78.516C77.8156 35.2847 77.2471 34.7412 77.2471 34.0715V26.5077C77.2471 25.838 77.8156 25.2944 78.516 25.2944H97.9689C98.6709 25.2944 99.2379 25.838 99.2379 26.5077L99.2394 34.07C99.2394 34.7412 98.6694 35.2847 97.9689 35.2847Z",
    fill: "black",
    fillOpacity: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3137_8300",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 92,
    width: 21,
    height: 20
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "b390be0aec"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M31.9146 92.3213H51.7086V111.554H31.9146V92.3213Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3137_8300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2289 111.412C32.5285 111.412 31.96 110.87 31.96 110.199L31.9615 93.8495C31.9615 93.1784 32.5285 92.6362 33.2289 92.6362H50.3319C51.0323 92.6362 51.5993 93.1784 51.5993 93.8495C51.6009 94.5192 51.0308 95.0613 50.3304 95.0613H34.4979V110.199C34.4979 110.87 33.9294 111.412 33.2289 111.412Z",
    fill: "black",
    fillOpacity: 0.75
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3137_8300",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 92,
    width: 21,
    height: 20
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "56b1cd03f1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M48.9919 92.3213H68.786V111.554H48.9919V92.3213Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3137_8300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6012 108.985H66.1647V95.0608H51.6012V108.985ZM67.4337 111.412H50.3322C49.6303 111.412 49.0618 110.868 49.0618 110.198V93.8476C49.0618 93.1779 49.6303 92.6343 50.3307 92.6343H67.4337C68.1341 92.6343 68.7011 93.1779 68.7011 93.8476V110.198C68.7011 110.868 68.1326 111.412 67.4337 111.412Z",
    fill: "black",
    fillOpacity: 0.75
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3137_8300",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 92,
    width: 20,
    height: 20
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "4bbeeba861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M66.0688 92.3213H85.8629V111.554H66.0688V92.3213Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3137_8300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5348 111.412C83.8343 111.412 83.2643 110.87 83.2643 110.199L83.2658 95.0613H67.4333C66.7329 95.0613 66.1628 94.5192 66.1628 93.8495C66.1644 93.1784 66.7314 92.6362 67.4318 92.6362H84.5348C85.2352 92.6362 85.8022 93.1784 85.8022 93.8495V110.199C85.8022 110.87 85.2337 111.412 84.5333 111.412H84.5348Z",
    fill: "black",
    fillOpacity: 0.75
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.78 95.0612C41.0795 95.0612 40.511 94.5176 40.511 93.8479V77.497C40.511 76.8273 41.0795 76.2837 41.78 76.2837H58.8829C59.5833 76.2837 60.1504 76.8273 60.1504 77.497C60.1519 78.1681 59.5818 78.7102 58.8814 78.7102H43.0489V93.8479C43.0489 94.5176 42.4804 95.0612 41.78 95.0612Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9842 95.0612C75.2838 95.0612 74.7152 94.5176 74.7152 93.8479V78.7102H60.1517V93.8479C60.1517 94.5176 59.5816 95.0612 58.8812 95.0612C58.1823 95.0612 57.6138 94.5176 57.6138 93.8479V77.497C57.6138 76.8273 58.1808 76.2837 58.8812 76.2837H75.9842C76.6846 76.2837 77.2516 76.8273 77.2516 77.497V93.8479C77.2516 94.5176 76.6831 95.0612 75.9842 95.0612Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4337 78.7101C66.7333 78.7101 66.1632 78.168 66.1632 77.4968L66.1647 62.3592H51.6012V77.4968C51.6012 78.168 51.0312 78.7101 50.3307 78.7101C49.6303 78.7101 49.0618 78.168 49.0618 77.4968V61.1459C49.0618 60.4762 49.6303 59.9326 50.3307 59.9326H67.4337C68.1341 59.9326 68.7011 60.4762 68.7011 61.1459V77.4968C68.7011 78.168 68.1326 78.7101 67.4322 78.7101H67.4337Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1643 66.8948H59.6758C58.9753 66.8948 58.4053 66.3527 58.4053 65.683C58.4068 65.0119 58.9738 64.4697 59.6742 64.4697H63.1643C63.8647 64.4697 64.4317 65.0133 64.4317 65.683C64.4332 66.3527 63.8647 66.8963 63.1643 66.8948Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6135 83.2474H51.125C50.4245 83.2474 49.8545 82.7038 49.8545 82.0341C49.856 81.3644 50.423 80.8208 51.1235 80.8208H54.6135C55.3139 80.8208 55.8809 81.3644 55.8809 82.0341C55.8824 82.7038 55.3139 83.2474 54.6135 83.2474Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7148 83.2474H68.2248C67.5259 83.2474 66.9558 82.7038 66.9558 82.0341C66.9573 81.3644 67.5243 80.8208 68.2248 80.8208H71.7148C72.4152 80.8208 72.9838 81.3644 72.9838 82.0341C72.9838 82.7038 72.4152 83.2474 71.7148 83.2474Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0627 99.597H42.5742C41.8738 99.597 41.3037 99.0548 41.3037 98.3852C41.3052 97.7155 41.8722 97.1719 42.5727 97.1719H46.0627C46.7631 97.1719 47.3302 97.7155 47.3302 98.3852C47.3317 99.0548 46.7631 99.5984 46.0627 99.597Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1643 99.597H59.6758C58.9753 99.597 58.4053 99.0548 58.4053 98.3852C58.4068 97.7155 58.9738 97.1719 59.6742 97.1719H63.1643C63.8647 97.1719 64.4317 97.7155 64.4317 98.3852C64.4332 99.0548 63.8647 99.5984 63.1643 99.597Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2656 99.597H76.7756C76.0751 99.597 75.5066 99.0548 75.5066 98.3852C75.5081 97.7155 76.0751 97.1719 76.7756 97.1719H80.2656C80.966 97.1719 81.533 97.7155 81.533 98.3852C81.533 99.0548 80.9645 99.5984 80.2641 99.5984L80.2656 99.597Z",
    fill: "black",
    fillOpacity: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehousingandfulfillment);
export default __webpack_public_path__ + "static/media/warehousing and fulfillment.656a6a1b8af8946b435f97af014fa3d5.svg";
export { ForwardRef as ReactComponent };